import {
  faSearch as MemberSearchIcon,
  faUsers as MemberIcon,
  faStore as MerchantIcon,
  faFlagCheckered as CampaignIcon,
  faTicketAlt as VoucherIcon,
  faBook as ReportIcon,
  faCreditCard as BulkTransactionsIcon,
  faFolder as FileIcon,
} from '@fortawesome/free-solid-svg-icons' // faUsers
import { ROUTES } from './routing'

import {
  accessControlNavigation,
  accessControlNavigationWithUserTypes,
} from 'setups/controller'
import { projectClient } from 'constants/project'
import { UserTypeNames } from 'setups_backup/usertypes'

const navModules = [
  {
    module: 'Member',
    route: {
      title: 'Member',
      path: ROUTES.MemberLookup,
      icon: MemberSearchIcon,
      className: 'mt-5 nav-text',
    },
  },
  {
    module: 'Subsquad',
    route: {
      title: 'Subsquad',
      path: ROUTES.SubsquadLookup,
      icon: MemberIcon,
      className: 'm-0 nav-text',
    },
  },
  {
    module: 'Merchant',
    route: {
      title: 'Merchant',
      path: ROUTES.MerchantLookup,
      icon: MerchantIcon,
      className: 'm-0 nav-text',
    },
  },
  {
    module: 'Merchant Subway',
    route: {
      title: 'Merchant',
      path: ROUTES.MerchantLookupSubway,
      icon: MerchantIcon,
      className: 'm-0 nav-text',
    },
  },
  {
    module: 'Voucher',
    route: {
      title: 'Voucher',
      path: ROUTES.VoucherList,
      icon: VoucherIcon,
      className: 'm-0 nav-text',
    },
  },
  {
    module: 'Reports',
    route: {
      title: 'Reports',
      path: ROUTES.ReportsList,
      icon: ReportIcon,
      className: 'm-0 nav-text',
    },
  },
  {
    module: 'Bulk Transactions',
    route: {
      title: 'Bulk Transactions',
      path: ROUTES.BulkTransactions,
      icon: BulkTransactionsIcon,
      className: 'm-0 nav-text',
    },
  },
  {
    module: 'Files',
    route: {
      title: 'Files',
      path: ROUTES.Files,
      icon: FileIcon,
      className: 'm-0 nav-text',
    },
  },
]

export const SIDEBARNAVIGATION_OLD = accessControlNavigation(
  projectClient,
  navModules
)

export const SIDEBARNAVIGATION = accessControlNavigationWithUserTypes({
  projectClient,
  navModules,
  userType: 'display_user',
  isTempBypass: true,
})

export const SIDEBARNAVIGATION_FN = (userType: string) =>
  accessControlNavigationWithUserTypes({
    projectClient,
    navModules,
    userType: userType as UserTypeNames,
    isTempBypass: false,
  })
